/*
  eslint
  react/no-array-index-key: off,
  jsx-a11y/media-has-caption: off
*/
import React, { PureComponent } from 'react';
import { getSeason } from '../../../../lib/seasons';

import styles from './styles.scss';

export class Camera extends PureComponent {
  static renderSeasonCamera(season) {
    if (!season) {
      return null;
    }

    const images = [];
    if (season.overlays && season.overlays.length) {
      images.push(...season.overlays.map((i, k) => (
        <img
          key={k}
          src={i}
          className={styles.HomeCamera__overlayer}
          alt="seasonal scenery"
        />
      )));
    }

    if (season.border) {
      const { res, className } = season.border;
      images.push(<img
        key={images.length}
        src={res}
        className={className}
        alt="seasonal scenery"
      />);
    }

    return <div className={styles.HomeCamera__overlayer}>{images}</div>;
  }

  static getVideoProps() {
    if (window.deprecatedVideoStream) {
      return {
        src: window.videostream,
        autoPlay: 'true',
      };
    }

    return {
      /* eslint-disable no-param-reassign */
      ref: (video) => {
        // do nothing if video is null
        if (!video) { return; }

        // TODO: might not need this with react 16
        // see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html / https://github.com/facebook/react/issues/11163
        video.srcObject = window.videostream;

        // only muted videos can autoplay
        // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
        video.muted = true;
        video.autoplay = true;
      },
      /* eslint-enable no-param-reassign */
    };
  }
  /* eslint-enable no-param-reassign */

  constructor(props) {
    super(props);
    this.state = { season: getSeason(Date.now()) };
  }


  componentDidMount() {
    if (window.platform !== 'ios') return;
    if (!this.props.features.camera.value) return;

    window.camera.show(0.25);
  }


  componentWillUnmount() {
    if (window.platform !== 'ios') return;
    if (!this.props.features.camera.value) return;

    window.camera.hide(0.25);
  }


  render() {
    const { season } = this.state;

    if (!this.props.features.camera.value) {
      return null;
    }
    if (window.platform === 'ios') {
      return <div className={styles.HomeCamera} />; // spaces the content correctly
    }
    if (!window.videostream) {
      return null;
    }

    return (
      <div className={styles.HomeCamera}>
        {Camera.renderSeasonCamera(season)}

        <video
          className={styles.HomeCamera__layer}
          hidden={this.state.confirm}
          {...Camera.getVideoProps()}
        />
      </div>
    );
  }
}


export default Camera;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/camera.jsx